import React, { memo } from 'react'

// form fields
import AppFormikRadio from 'utlis/helpers/forms/AppFormikRadio'

function FormFeatured(props) {
    const {
        formik
    } = props

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    <div className="d-flex align-items-center mb-2">
                        {/* heading */}
                        <p className="box-heading st-fs-15 st-fw-600 st-text-color me-3">Feature on the store's front page</p>
                        {/* form field */}
                        <AppFormikRadio
                            formik={formik} // formik object
                            labelClass={"align-items-center mb-0"} // class name for main wrapper
                            checkedText={"Enabled"} // name when the radio is checked
                            unCheckedText={"Disabled"} // name when the radio is checked
                            // isRequired={true} // is this field is required or not to show the red star sign
                            formikFieldName={"isFeatured"} // important: formik value name for the input
                        />
                    </div>
                    <p className="st-fs-13 st-text-color2">Product displayed as featured on the front page draw your customer's attention and help promote specific items.</p>
                </div>
            </div>
        </React.Fragment>
    )
}


export default memo(FormFeatured)